
class DummyTarget {
  // linkState's input event detection checks for a "nodeName" property
  // https://github.com/developit/linkstate/blob/master/src/index.js#L19
  nodeName = 'hoppler-dummy-target';
  type = 'hoppler-dummy-target';
  value: any;

  constructor(value: any) {
    this.value = value;
  }
}

export class DummyInputEvent {
  value: any;
  target: DummyTarget;

  constructor(value: any) {
    this.target = new DummyTarget(value);
  }

  static createWithValue(value: any): Event {
    return new DummyInputEvent(value) as any as Event;
  }
}
